import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaCrown } from "react-icons/fa";
import { PLAN_TYPES, getCurrentSubscription } from "../services/subscriptionService";
import { planBadge } from "./PlanCard";

const PLAN_ROWS = [
  { type: PLAN_TYPES.BROADCASTER, label: "Go Live plan" },
  { type: PLAN_TYPES.VIEWER, label: "Viewer plan" },
];

// The user's broadcaster and viewer plans with a link to manage them
const MyPlansCard = () => {
  const [subscriptions, setSubscriptions] = useState({});

  useEffect(() => {
    PLAN_ROWS.forEach(({ type }) =>
      getCurrentSubscription(type)
        .then((subscription) => setSubscriptions((prev) => ({ ...prev, [type]: subscription })))
        .catch(() => {})
    );
  }, []);

  return (
    <div className="mt-6 p-4 md:p-8 bg-[#F4F4F4] rounded-2xl shadow-lg">
      <div className="mb-4 flex items-center justify-between gap-3">
        <h2 className="text-lg font-semibold">My Plans</h2>
        <Link
          to="/subscription"
          className="flex items-center gap-2 rounded-full bg-gradient-to-r from-[#08AEEA] to-[#1DE78B] px-4 py-1.5 text-sm font-semibold text-white"
        >
          <FaCrown /> Manage
        </Link>
      </div>
      <div className="space-y-3">
        {PLAN_ROWS.map(({ type, label }) => {
          const subscription = subscriptions[type];
          return (
            <div key={type} className="bg-white p-3 md:p-5 rounded-[12px] flex flex-wrap justify-between items-center gap-2 shadow-sm">
              <span className="text-gray-500">{label}</span>
              <span className="text-sm">
                <span className="font-semibold text-[#095228]">
                  {subscription ? subscription.current_plan.base_plan_name || subscription.current_plan.plan_name : "..."}
                </span>
                {subscription && <span className="ml-2 text-gray-500">{planBadge(subscription)}</span>}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MyPlansCard;
